import Swiper from "swiper";
import { Navigation, Autoplay } from "swiper/modules";
import { getMobileMediaQuery, getRem } from "./utils/utils";
import "swiper/css";
import "swiper/css/navigation";

type SliderOptions = {
  slidesPerView?: number | "auto" | undefined;
  spaceBetween?: number;
  speed?: number;
};

type AdditionalBreakpoints = {
  breakpoints?: Record<number, SliderOptions>;
};

const defaultOptions: SliderOptions & AdditionalBreakpoints = {
  slidesPerView: "auto",
  spaceBetween: 16,
  speed: 700,
};

const initSlidersFunction = (
  sliderContainers: NodeListOf<HTMLDivElement>,
  prefix: string = "data-slider",
  options = defaultOptions,
) => {
  for (const slider of sliderContainers) {
    const prevButton = slider.querySelector(
      "[" + prefix + "-prev-button]",
    ) as HTMLButtonElement;
    const nextButton = slider.querySelector(
      "[" + prefix + "-next-button]",
    ) as HTMLButtonElement;
    const sliderInstance = slider.querySelector(
      "[" + prefix + "-instance]",
    ) as HTMLDivElement;

    new Swiper(sliderInstance, {
      ...options,
      modules: [Navigation],
      navigation: {
        prevEl: prevButton,
        nextEl: nextButton,
      },
    });
  }
};

const initTrustSlider = () => {
  const trustSlider = document.getElementById("trust-slider");

  if (!trustSlider) return;

  new Swiper(trustSlider, {
    modules: [Autoplay],
    loop: true,
    speed: 3000,
    allowSlidePrev: false,
    autoplay: {
      delay: 0,
      disableOnInteraction: false,
    },
    // allowTouchMove: true,
    grabCursor: true,
    breakpoints: {
      0: {
        slidesPerView: 2,
        spaceBetween: 16 * getRem(),
      },
      769: {
        slidesPerView: 6,
        spaceBetween: 20 * getRem(),
      },
    },
  });
};

export function sliderInit() {
  const sliderContainers = document.querySelectorAll(
    "[data-slider]",
  ) as NodeListOf<HTMLDivElement>;

  if (sliderContainers.length > 0) {
    initSlidersFunction(sliderContainers);
  }

  const projectSliderContainers = document.querySelectorAll(
    "[data-project-slider]",
  ) as NodeListOf<HTMLDivElement>;

  if (projectSliderContainers.length > 0) {
    initSlidersFunction(projectSliderContainers, "data-project-slider", {
      slidesPerView: 1.1,
      spaceBetween: 16,
      speed: 700,
      breakpoints: {
        769: {
          slidesPerView: 2.5,
          spaceBetween: 16 * getRem(),
        },
        1200: {
          slidesPerView: 4,
          spaceBetween: 20 * getRem(),
        },
      },
    });
  }

  const teamSlider = document.querySelectorAll(
    "[data-team-slider]",
  ) as NodeListOf<HTMLDivElement>;

  if (teamSlider.length > 0) {
    initSlidersFunction(teamSlider, "data-team-slider", {
      speed: 900,
      breakpoints: {
        0: {
          slidesPerView: "auto",
          spaceBetween: 16 * getRem(),
        },
        769: {
          slidesPerView: 4,
          spaceBetween: 20 * getRem(),
        },
      },
    });
  }

  const modalProjectSliderContainers = document.querySelectorAll(
    "[data-modal-project-slider]",
  ) as NodeListOf<HTMLDivElement>;

  if (modalProjectSliderContainers.length > 0) {
    initSlidersFunction(
      modalProjectSliderContainers,
      "data-modal-project-slider",
      {
        slidesPerView: 1,
        spaceBetween: 16,
        speed: 900,
      },
    );
  }

  initTrustSlider();
}
